import { store, authActions } from "_store";

export const fetchWrapper = {
  get: request("GET"),
  post: request("POST"),
  put: request("PUT"),
  delete: request("DELETE"),
};

function request(method) {
  return (url, body, multipart = null) => {
    const requestOptions = {
      method,
      headers: authHeader(url),
      credentials: "same-origin",
    };
    if (multipart && multipart === "multipart") {
      requestOptions.body = body;
    } else if (body) {
      requestOptions.headers["Content-Type"] = "application/json";
      requestOptions.body = JSON.stringify(body);
    }
    return fetch(url, requestOptions).then(handleResponse);
  };
}

// helper functions

function authHeader(url) {
  // return auth header with jwt if user is logged in and request is to the api url
  const token = authToken();
  const isLoggedIn = !!token;
  const isApiUrl = url.startsWith(process.env.REACT_APP_OCTA_API_URL);
  if (isLoggedIn && isApiUrl) {
    return { Authorization: `Bearer ${token}` };
  } else {
    return {};
  }
}

function authToken() {
  return store.getState().auth.value?.token;
}

async function handleResponse(response) {
  const isJson = response.headers
    ?.get("content-type")
    ?.includes("application/json");
  const isPDF = response.headers
    ?.get("content-type")
    ?.includes("application/pdf");
  const isZip = response.headers
    ?.get("content-type")
    ?.includes("application/zip");
  const isXls = response.headers
    ?.get("content-type")
    ?.includes(
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    );
  const isXls2 = response.headers
    ?.get("content-type")
    ?.includes(
      "application/octet-stream"
    );
  try {
    if (isPDF || isZip) {
      const contentDisposition = response.headers.get("Content-Disposition");
      let filename = "downloaded_file";
      if (contentDisposition && contentDisposition.includes("filename=")) {
        filename = contentDisposition.split("filename=")[1].replace(/"/g, "");
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      // console.log("a ", filename, response, contentDisposition);

      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      return response;

      // const blob = await response.blob();
      // const url = window.URL.createObjectURL(blob);
      // window.open(url);
      // await window.URL.revokeObjectURL(url);
      // return response;
    }
    if (isXls || isXls2) {
      //! for file name need access from backend
      //   const contentDisposition = response.headers?.get("content-disposition");
      //   let filename = "Rtv data";
      // if (contentDisposition && contentDisposition.includes("filename=")) {
      //   const match = contentDisposition.match(/filename="?([^"]+)"?/);
      //   if (match && match[1]) {
      //     filename = match[1];
      //   }
      // }
      return response;
    }
  } catch {
    return response.body;
  }
  const data = isJson ? await response.json() : null;
  const cookieHeader = response.headers.get("Set-Cookie");
  if (cookieHeader) {
    sessionStorage.setItem("currentUser", cookieHeader);
  }
  // check for error response
  if (!response.ok) {
    if ([401, 403].includes(response.status) && authToken()) {
      // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
      const logout = () => store.dispatch(authActions.logout());
      logout();
    }

    // get error message from body or default to response status
    const error = (data && data.error && data.error.message) || response.status;
    return Promise.reject(error);
  }

  return data;
}
